import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { HttpClient, HttpHeaders ,HttpErrorResponse} from '@angular/common/http';
import 'rxjs/add/operator/map';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { DtoService } from '../../services/dto.service';
import { UtilService } from '../../services/util.service';
import { FunctService } from '../../services/funct.service';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './app-navigation-bar.component.html',
  styleUrls: ['./app-navigation-bar.component.scss']
})

export class AppNavigationBarComponent implements OnInit, OnChanges {
  
  promotionCount : any;
  promotionList : any;
  token : any;
  routerName: any;
  //isUserLoggedIn: any;
  deviceId: any;
  deviceRouterName: any;
  inactiveClass : any;
  @Input() isUserLoggedIn?: boolean; 

  constructor(
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private dto: DtoService,
    private http: HttpClient,
    private util: UtilService, 
    private router: Router,
    private storage: LocalStorageService,
    private funct: FunctService) {
      
    
  }
  
  ngOnInit(): void {
    this.deviceId = this.storage.retrieve('localDeviceId');
    if(this.isUserLoggedIn == undefined)
    {
    this.isUserLoggedIn = this.storage.retrieve('isUserLoggedIn');
    }
    this.routerName = this.router.url;
    this.promotionCount = this.storage.retrieve('localpromotionCount');
    this.inactiveClass = "inactive";
  }

  openPage(routeUrl: string) {
    if (this.router.url != routeUrl) {
      this.router.navigate([routeUrl],{replaceUrl: false});    
    }
  }
  async ngOnChanges(changes: SimpleChanges): Promise<void>
  {
      if (changes.isUserLoggedIn?.currentValue)
      {
        const token = await this.storage.retrieve('token');
        this.isUserLoggedIn = changes.isUserLoggedIn.currentValue;
      }
    }
}
